import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { nsOptions } from '../i18n';
import '../assets/css/two-factor.css';

@withTranslation('', nsOptions)
class BackupCodesDisplay extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    codes: PropTypes.arrayOf(PropTypes.string).isRequired,
    showActions: PropTypes.bool,
    onFinish: PropTypes.func,
  };

  static defaultProps = {
    showActions: true,
    onFinish: null,
  };

  state = {
    copied: false,
  };

  handleDownload = () => {
    const { t, codes } = this.props;
    const content = [
      t('twoFactor:backup-codes.download-header'),
      '',
      `Generated: ${new Date().toLocaleString()}`,
      '',
      ...codes,
      '',
      t('twoFactor:backup-codes.download-footer'),
    ].join('\n');

    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = t('twoFactor:backup-codes.download-filename');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  handlePrint = () => {
    window.print();
  };

  handleCopy = async () => {
    const { codes } = this.props;
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      this.setState({ copied: true });
      setTimeout(() => {
        this.setState({ copied: false });
      }, 3000);
    } catch (error) {
      console.error('Failed to copy codes:', error);
    }
  };

  render() {
    const {
      t, codes, showActions, onFinish,
    } = this.props;
    const { copied } = this.state;

    return (
      <div className="two-factor-backup-codes">
        <div className="two-factor-backup-warning">
          {t('twoFactor:backup-codes.warning')}
        </div>

        <div className="two-factor-codes-grid">
          {codes.map((code) => (
            <div className="two-factor-code-item">
              {code}
            </div>
          ))}
        </div>

        {showActions && (
          <div className="two-factor-codes-actions">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.handleDownload}
            >
              <FontAwesomeIcon icon={['fal', 'arrow-to-bottom']} className="mr-2" />
              {t('twoFactor:setup.step-4.download-button')}
            </button>

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.handlePrint}
            >
              <FontAwesomeIcon icon={['fal', 'file-pdf']} className="mr-2" />
              {t('twoFactor:setup.step-4.print-button')}
            </button>

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.handleCopy}
            >
              <FontAwesomeIcon
                icon={['fal', copied ? 'check' : 'copy']}
                className="mr-2"
              />
              {copied
                ? t('twoFactor:setup.step-4.copied')
                : t('twoFactor:setup.step-4.copy-button')}
            </button>

            {onFinish && (
              <button
                type="button"
                className="btn btn-newturquoise-1"
                onClick={onFinish}
              >
                {t('twoFactor:setup.step-4.finish-button')}
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default BackupCodesDisplay;
